import './App.css';

function App() {
  return (
    <div className="App">
      {/* Hero Section */}
      <header className="hero">
        <img src="/RUNICLogo.png" alt="RUNIC Solutions Logo" className="hero-logo" />
        <h1 className="hero-title">RUNIC Solutions</h1>
        <p className="hero-subtitle">
          Empowering businesses through elegant, modern software.
        </p>
        <a href="#services" className="hero-button">
          Explore Our Work
        </a>
      </header>

      {/* Services Section */}
      <section id="services" className="services">
        <h2>What We Do</h2>
        <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <p>
            We build practical software solutions for real people and provide
            consulting for small businesses and individuals. Our work is rooted
            in privacy, security, and fair pricing, with every decision focused
            on delivering excellent user experiences while running a sustainable
            business.
          </p>
          <p style={{ marginTop: '1rem' }}>
            Contact us: <a href="mailto:runicenterprise@gmail.com">runicenterprise@gmail.com</a>
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2025 RUNIC Solutions — Crafting technology imbued with purpose.</p>
      </footer>
    </div>
  );
}

export default App;
